import React, { createContext, useContext, useState } from "react";


const UserContext = createContext(null);

export const useUser = () => useContext(UserContext);


export const UserProvider = (props) => {

    const isAuth = false;

    const [sideMenu, setSideMenu] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    const whatsappApi = 'https://api.whatsapp.com/send?phone=447759992968';


    return (
        <UserContext.Provider value={{
            isAuth,
            setSideMenu,
            sideMenu,
            setIsScrolled,
            isScrolled,
            whatsappApi
        }}
        >
            {props.children}
        </UserContext.Provider>
    );
}

export default UserContext;
